import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import styled from "styled-components";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/content-hub/theme/constants";
import { Button } from "@/content-hub/theme/primitives/button/button";
import RichText from "@/content-hub/theme/primitives/rich-text";
const StyledContainer = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(24)};

  h3,
  p {
    margin-bottom: 0;
  }
`;

export const StyledButtonContainer = withViewportStyle("div")`
  .button-primitive {
    font-size: ${rem(15)};
    font-weight: 500;
    padding: ${rem(10)} ${rem(40)};
    line-height: ${rem(28)};
    max-width: ${rem(300)};
    width: max-content;
    
    ${(props) => props.$viewport.mobile`
      padding: ${rem(12)};
      max-width: 100%;
      width: 100%;
    `}
  }
  `;

export type TextWithButtonProps = {
  showCTA?: boolean;
};

export default function TextWithButton(props: TextWithButtonProps) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <StyledContainer ref={connect}>
      <Element
        id="paragraph-item-sub-title"
        is={RichText}
        text={`<h3>The Critical Role of Events in Modern Marketing Strategies</h3>`}
      />
      <Element
        id="paragraph-item-description"
        is={RichText}
        text={`<p>Run personalized AI-powered events that reflect your brand, build community, and create a lasting impression with your audience from start to finish.</p>`}
      />
      {props.showCTA && (
        <StyledButtonContainer>
          <Element
            id="paragraph-item-cta"
            is={Button}
            text={"Download PDF"}
            action={{
              kind: "ExternalLink",
              href:
                "https://assets.ringcentral.com/us/ebook/critical-role-events-marketing-strategies.pdf",
            }}
            colorSet={{
              background: ColorLabels["BRAND-PRIMARY"],
              text: ColorLabels["BRAND-SECONDARY-DARK"],
              border: ColorLabels["BRAND-PRIMARY"],
            }}
          />
        </StyledButtonContainer>
      )}
    </StyledContainer>
  );
}

TextWithButton.craft = {
  custom: {
    displayName: "Paragraph Item",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
